import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpShop'

// The retailers of the Deals (Steam, GOG, Eneba...). Staff-only on shop-api: admin/retailers.
export const retailerList = (params = '') => Http.get(`/admin/retailers${serialize(params)}`)
export const retailerCreate = data => Http.post('/admin/retailers', data)
export const retailerUpdate = (id, data) => Http.put(`/admin/retailers/${id}`, data)
export const retailerDestroy = id => Http.delete(`/admin/retailers/${id}`)
